import Parse from 'parse'

export const CONSOLIDATED_ORDER_PDF_MODULE = 'ConsolidatedOrder'
export const CONSOLIDATED_ORDER_ANALITIC_PDF_MODULE = 'ConsolidatedOrderAnalitic'

const convertBase64ToPdfBlob = (base64Content) => {
  const binaryContent = window.atob(base64Content)
  const bytes = new Uint8Array(binaryContent.length)
  for (let index = 0; index < binaryContent.length; index += 1) {
    bytes[index] = binaryContent.charCodeAt(index)
  }
  return new Blob([bytes], { type: 'application/pdf' })
}

export const findLatestPdfSnapshotId = async (module, recordId) => {
  const snapshots = await Parse.Cloud.run('listPdfSnapshots', { module, recordId, limit: 1 })
  return snapshots.length ? snapshots[0].snapshotId : null
}

export const openPdfFromSnapshot = async (snapshotId) => {
  const { base64 } = await Parse.Cloud.run('renderPdfSnapshot', { snapshotId })
  const pdfUrl = URL.createObjectURL(convertBase64ToPdfBlob(base64))
  window.open(pdfUrl, '_blank')
}
